import * as React from "react";
export var renderEventName = function (event, componentPrefix) {
    return (React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__event-name", "data-uat": "div-ev-list-" + componentPrefix + "-event-name" },
        React.createElement("span", { className: "rj-ev-list__name-text", "data-uat": "span-ev-list-name-text" }, event.eventName)));
};
//# sourceMappingURL=renderEventName.js.map